import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as moment from 'moment-timezone';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { NOTIFICATION_ROUTES } from 'src/app/utils/notification-routes';
@UntilDestroy()

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.css']
})
export class NotificationsComponent {
  search = '';
  user:any;
  timeZone:any;
  // today by default, the picker shows the same range
  dateRange: any = [moment().startOf('day').toDate(), moment().endOf('day').toDate()];
  notifications = [];
  constructor(
    private sharedDataService : SharedDataService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    this.getUser();
    this.getNotifications();
  }

  getNotifications() {
     const queryParams = {
      sortBy: 'createdAt:desc',
      ...(this.dateRange && {
        time: [moment(this.dateRange[0]).startOf('day').toISOString(), moment(this.dateRange[1]).endOf('day').toISOString()],
      }),
    };
    this.sharedDataService
      .getNotifications(queryParams)
      .pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data) {
          this.notifications = data.results;
        }
      });
  }

  getUser() {
    this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe(data => {
      if (data) {
        this.user = data;
        this.timeZone = this.user.timeZone;
      }
    })
  }

  trackById(index: number, notification: any) {
    return notification.id || notification._id;
  }

  onNotificationClick(notification: any) {
    if (notification && !notification.isRead) {
      notification.isRead = true;
      this.sharedDataService.decrementUnreadNotificationCount(1);
      // not tied to untilDestroyed: leaving the page must not cancel the request
      this.sharedDataService.markNotificationAsRead(notification.id || notification._id).subscribe({ error: () => { } });
    }
    const route = NOTIFICATION_ROUTES[notification?.type];
    if (route) {
      this.router.navigate([route]);
    }
  }

  onDateRangeChange(event: any) {
    // wait until both from and to are picked, clearing shows everything again
    if (event?.[0] && !event?.[1]) {
      return;
    }
    this.dateRange = event?.[0] ? event : null;
    this.getNotifications();
  }
}
